import React from "react";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../../common/providers";
import { CustomButton, CustomButtonLink, icon, VerticalDivider } from "../../../../../common/components";
import styles from "./ProjectDocsInfo.module.css";
import { NavUtils } from "../../../../../navigation";
import { InfoBox } from "../..";

export default function ProjectDocsInfo({
	className = "",
	isInProject = false,
	onChangeUrl,
	projectId,
	totaldocuments,
	totalpages,
}) {
	return (
		<InfoBox
			actions={
				isInProject && (
					<CustomButtonLink
						className={styles.action}
						color="secondary"
						size="sm"
						to={NavUtils.goToTeam(projectId)}
						variant="outlined"
					>
						{translate("dashboards.project-team-info-card.display-team")}
					</CustomButtonLink>
				)
			}
			className={className}
			icon={icon.faFileAlt}
			title={translate("dashboards.project-docs-infos.title.docs-uploaded")}
		>
			<div className={styles.container}>
				<div className={styles.figuresContainer}>
					<div className={styles.figure}>
						<span className={styles.figure__number}>{totaldocuments}</span>
						<span className={styles.figure__label}>
							{translate("dashboards.project-docs-infos.card.content.documents")}
						</span>
					</div>
					<VerticalDivider />
					<div className={styles.figure}>
						<span className={styles.figure__number}>{totalpages}</span>
						<span className={styles.figure__label}>
							{translate("dashboards.project-docs-infos.card.content.pages")}
						</span>
					</div>
				</div>
				{isSegFeatureEnabled(SegFlags.DOCUMENT_CENTER) && (
					<CustomButton
						className={styles.manageDocumentsBtn}
						variant="outlined"
						onClick={() => onChangeUrl(NavUtils.goToDocumentCenter(projectId))}
					>
						{translate("dashboards.project-docs-infos.card.manage-documents")}
					</CustomButton>
				)}
			</div>
		</InfoBox>
	);
}
